<template>
  <div v-if="visible" class="content-share-area mb-4">
    <div class="uk-alert-primary2 p-4">
      <button class="csa-close-btn" type="button" @click="$emit('close')">
        <i class="uil-times"></i>
      </button>
      <h4>
        <i class="uil-share-alt"></i>
        {{ $t("collectionDetail.share_collection") }}
      </h4>
      <p> {{ $t("collectionDetail.share_message_content") }} </p>
      <div class="pt-4 pb-3"></div>
      <button class="btn csa-btn-users" type="button" @click="$emit('open-modal')">
        <i class="uil-user-plus"></i>
        {{ $t("collectionDetail.person_add_remove") }}
      </button>
      <div v-if="selectedUsers.length" class="csa-user-list">
        <span v-for="user in selectedUsers" :key="user.id" class="uk-label csa-user-badge">
          <i class="uil-user"></i> {{ user.name + ' ' + user.surname }}
        </span>
      </div>
      <textarea v-model="message" :placeholder="$t('collectionDetail.write_your_message_here')"
                cols="30"
                rows="2"></textarea>
      <div class="csa-actions">
        <button class="btn btn-secondary" type="button" @click="save">
          {{ $t("collectionDetail.send") }}
        </button>
        <button class="btn btn-soft-secondary" type="button" @click="$emit('close')">
          {{ $t("collectionDetail.cancel") }}
        </button>
        <button class="btn csa-btn-history" type="button" @click="$emit('open-history')">
          <i class="uil-history"></i> {{ $t("collectionDetail.share_history") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "CollectionShareArea",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    collectionId: {
      type: [String, Number],
      required: true
    },
    users: {
      type: Array,
      default: () => []
    },
    sharedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      message: null
    };
  },
  computed: {
    selectedUsers() {
      return this.users.filter(user => this.sharedIds.includes(user.id));
    }
  },
  methods: {
    save() {
      ApiService.post("api/collection-shared/update/" + this.collectionId, {
        shared_ids: this.sharedIds,
        message: this.message,
      }).then(() => {
        this.$emit("saved");
        this.$emit("close");
      }).catch(() => {
        this.$emit("error");
      });
    }
  }
};
</script>

<style scoped>
/* ═══════════════════════════════════════
   GENEL (Web + Mobil)
   ═══════════════════════════════════════ */

/* Kart: beyaz bg, border-radius 14px, soft shadow */
.content-share-area .uk-alert-primary2 {
  background: #fff !important;
  color: #333 !important;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* Kapat butonu: sağ üst, touch target 44x44 */
.csa-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f1f5;
  border: none;
  border-radius: 50%;
  color: #555;
  font-size: 18px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.csa-close-btn:active {
  transform: scale(0.95);
  opacity: 0.85;
}

/* Kart position: relative for close btn */
.content-share-area .uk-alert-primary2 {
  position: relative;
}

/* Başlık */
.content-share-area h4 {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
  color: #222;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Açıklama */
.content-share-area p {
  font-size: 16px;
  line-height: 1.5;
  color: #555;
}

/* Butonlar: desktop 36px, radius 10px */
.content-share-area .btn {
  min-height: 36px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  -webkit-tap-highlight-color: transparent;
}

/* Kişi listesi butonu: outlined, soft stil */
.csa-btn-users {
  background: #fff !important;
  border: 1.5px solid #666CFF !important;
  color: #666CFF !important;
  margin-bottom: 16px;
}

.csa-btn-users:hover {
  background: #f5f5ff !important;
}

/* Paylaşım geçmişi butonu: soft/ghost stil, sağa yasla */
.csa-btn-history {
  background: #f0f1f5 !important;
  border: none !important;
  color: #555 !important;
  margin-left: auto;
}

.csa-btn-history:hover {
  background: #e5e6ea !important;
}

/* Active state — zorunlu */
.content-share-area .btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

/* Disabled state */
.content-share-area .btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Kullanıcı listesi: flex-wrap + gap */
.csa-user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0 16px;
}

/* Kullanıcı badge: pill chip */
.csa-user-badge {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  min-height: 32px;
  padding: 4px 12px !important;
  border-radius: 20px !important;
  background: #f0f1f5 !important;
  color: #333 !important;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  margin: 0 !important;
}

/* Alt buton grubu */
.csa-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

/* Textarea: min-height, radius, font */
.content-share-area textarea {
  width: 100%;
  min-height: 96px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.5;
  padding: 12px 16px;
  background: #f8f9fb;
  border: 1px solid #dcdee3;
  color: #333;
  resize: vertical;
}

.content-share-area textarea:focus {
  border-color: #666CFF;
  background: #fff;
  outline: none;
}

/* Spacing düzeltmeleri — 8pt grid */
.content-share-area .pt-4.pb-3 {
  padding: 8px 0 !important;
}

/* ═══════════════════════════════════════
   MOBİL (≤768px)
   ═══════════════════════════════════════ */
@media (max-width: 768px) {
  /* Kart padding */
  .content-share-area .uk-alert-primary2 {
    padding: 16px !important;
  }

  /* Butonlar: full-width, 48px touch target */
  .content-share-area .btn {
    width: 100%;
    min-height: 48px;
    font-size: 16px;
    padding: 0 24px;
  }

  /* Kapat butonu: mobil touch target */
  .csa-close-btn {
    width: 44px;
    height: 44px;
    font-size: 20px;
  }

  /* Hover devre dışı */
  .content-share-area .btn:hover {
    transform: none !important;
  }

  /* Kullanıcı badge: touch-friendly */
  .csa-user-badge {
    min-height: 36px;
    font-size: 14px;
  }

  /* Textarea touch */
  .content-share-area textarea {
    min-height: 80px;
  }
}
</style>
